import React from 'react'
import { InView } from 'react-intersection-observer'
import { ButtonPrimary } from '../../../../../utils/buttons'
import { blockInviewHandler } from '../../../../../utils/inview'
import { ButtonBlock } from '../blocksState'

export const ButtonBlockLayout = (props: ButtonBlock) => (
  <InView
    as="div"
    threshold={0}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--button block--wysiwyg"
  >
    <div className="block__inner container--s gutter--m">
      <ButtonPrimary
        kind="link"
        size="s"
        to={props.link.url}
        label={props.link.title}
      />
    </div>
  </InView>
)
